import React from 'react';
import error from '@client/shared/images/error.svg';
import PropTypes from 'prop-types';
import styles from './errorBox.scss';

export const ErrorBox = ({
  title = 'Åh nej! Sidan du letade efter kunde inte hittas!',
  message = 'Sidan har antingen flyttats eller så finns den inte kvar.',
  link = process.env.REACT_APP_HLF_PUBLIC_URL,
  linkText = 'Tillbaka till startsidan',
}) => {
  return (
    <div className={styles.errorBox} data-nosnippet>
      <img src={error} alt="error icon" />
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.message}>{message}</p>
      <a className={styles.button} href={link}>
        {linkText}
      </a>
    </div>
  );
};

ErrorBox.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  linkText: PropTypes.string,
  link: PropTypes.string,
};
